import { gql } from "@apollo/client";

const GET_ORDER_COMMISSION = gql`
  query {
    getOrderCommission {
      data {
        isOrderBasedCommission
      }
      status
      error
    }
  }
`;

export default GET_ORDER_COMMISSION;
